module.exports = __webpack_public_path__ + "static/media/logo-header.85a7efe7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-header.png
// module id = 286
// module chunks = 0